class TrustpilotRating extends HTMLElement {
  connectedCallback() {
    this.innerHTML = /* html */ `
      <p class="trustpilot-rating mb-0 text-center">
        <a
          href="https://nl.trustpilot.com/review/wallable.nl?utm_medium=Trustbox&utm_source=EmailSignature2"
          data-i18n-href="components.trustpilot.reviewUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://emailsignature.trustpilot.com/signature/nl-NL/2/625eee8d230116b4f2ab2f13/text.png"
            data-i18n-src="components.trustpilot.ratingImageUrl"
            data-i18n-alt="components.trustpilot.ratingAlt"
            height="16"
            class="trustpilot-rating__text"
            alt="Trustpilot-beoordeling"
          />
          <br />
          <img
            src="https://emailsignature.trustpilot.com/signature/nl-NL/2/625eee8d230116b4f2ab2f13/stars.png"
            data-i18n-src="components.trustpilot.starsImageUrl"
            data-i18n-alt="components.trustpilot.starsAlt"
            width="160"
            height="40"
            class="trustpilot-rating__stars"
            alt="Trustpilot-sterren"
          />
        </a>
        <br />
        <a
          href="https://nl.trustpilot.com/review/wallable.nl?utm_medium=Trustbox&utm_source=EmailSignature2"
          data-i18n-href="components.trustpilot.reviewUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://emailsignature.trustpilot.com/brand/s/2/logo.png"
            data-i18n-alt="components.trustpilot.logoAlt"
            width="79"
            height="20"
            class="trustpilot-rating__logo"
            alt="Trustpilot-logo"
          />
        </a>
      </p>
    `;
  }
}

customElements.define("trustpilot-rating", TrustpilotRating);
